const points = {
    test: 'https://dev-engine.amateum.com/',
    preprod: 'https://preprod-api-mf.rfs.ru/',
    prod: 'https://api-mf.rfs.ru/'
}

export const ENDPOINT = points[process.env.INSTANCE] || points.test
